import { combineReducers } from "redux";
import { GIVING_FORM_PAGINATION_SCOPE } from "./scopes";
import "./types";

import paginationReducer, { initialState as paginationInitial } from "data/pagination";
import parentCampaignReducer, {
  initialState as campaignInitial,
} from "data/parent-campaign";
import allocationSelectionReducer, {
  initialState as allocationInitial,
} from "./allocation-selection";
import billingReducer, { initialState as billingInitial } from "./billing";
import routesReducer, { initialState as routesInitial } from "./routes";

export const initialState = {
  routes: routesInitial,
  allocation_selection: allocationInitial,
  billing: billingInitial,
  parentCampaign: campaignInitial,
  pagination: paginationInitial,
};

export default combineReducers({
  routes: routesReducer,
  allocation_selection: allocationSelectionReducer,
  billing: billingReducer,
  parentCampaign: parentCampaignReducer,
  pagination: paginationReducer(GIVING_FORM_PAGINATION_SCOPE),
});
